import React, {Component} from 'react';

import './styles.scss';


export default class Category extends Component {

    render() {
        return (
            <div className={"category"} onClick={this.props.onClick}>
                <div className={"color"} style={{backgroundColor:this.props.color}}/>
                <div className={"name"}>{this.props.text}</div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/containers/dashboard-spl/performancePerTurn/components/category/Category.js